<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert type="info" text class="body-2">
      Fitur kuesioner atau fitur survei adalah fitur yang dapat dimanfaatkan untuk melakukan berbagai kebutuhan yang ada
      di instansi seputar dengan kebutuhan polling, penjajakan, pengisian tugas, jajak pendapat, dan lain sebagaimana.
      Bisa dikirimkan khusus ke pengguna tertentu atau bahkan ke semua pengguna yang ada instansi. Terdapat fitur
      statistik untuk mengetahui hasilnya. Bahkan dapat diunduh datanya
    </v-alert>
    <m-card-list
      titleLock="Kuesioner"
      descLock=""
      two-line
      title="Kuesioner"
      label-cari="Cari Kuesioner"
      search
      :add="isCan('kuesioner.store')"
      :items="items"
      :headers="headers"
      :refresh="false"
      @refresh="load"
      :page="page"
      footer
      @search="
            (search) => {
              textSearch = search
              load()
            }
          "
      @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
      @add="add"
    >
      <template v-slot:action_ext>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" depressed small class="rounded pa-5 grey lighten-3" icon @click="modal = true">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filter</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" depressed small class="rounded ml-3 pa-5 grey lighten-3" icon @click="load">
              <v-icon>mdi-refresh-circle</v-icon>
            </v-btn>
          </template>
          <span>Muat Ulang</span>
        </v-tooltip>
      </template>
      <template v-slot:items="{ props, item }">
        <tr>
          <td class="py-3">
            <span class="font-weight-medium"> {{ getDeepObj(item, 'nama') }}</span>
            <div v-if="getDeepObj(item, 'wkt_mulai') || getDeepObj(item, 'wkt_selesai')" class="grey--text caption">
              <i
              >Aktif {{ getDeepObj(item, 'wkt_mulai') | toSDN }} s/d
                {{ getDeepObj(item, 'wkt_selesai') | toSDN }} </i
              >|
              {{ M_PERIOD[getDeepObj(item, 'k_tipe_pengisian') || 1] }}
            </div>
          </td>
          <td>
            <v-chip :color="M_STATUS[getDeepObj(item, 'status_tayang')]['color']" outlined small>
              {{ M_STATUS[getDeepObj(item, 'status_tayang')]['text'] }}
            </v-chip>
          </td>
          <td> {{ getDeepObj(item, 'jumlah') || 0 }}</td>
          <td>
            {{ getDeepObj(item, 'users_created_by.nama') || '' }}
          </td>
          <td>
            <div>{{ getDeepObj(item, 'updated_at') | toDT }}</div>
            <div class="grey--text caption" v-if="getDeepObj(item, 'users_updated_by.nama')">
              Oleh: {{ getDeepObj(item, 'users_updated_by.nama') }}
            </div>
          </td>
          <td>
            <m-menu left style="float: right" :items="more_menu" :object="item" />
          </td>
        </tr>
      </template>
    </m-card-list>
    <DlgChange ref="kelola" :users="allUsers" :groups="allGroup" @reload="load" />
    <v-dialog v-model="modal" max-width="600px">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon class="mr-3 white--text">mdi-filter-variant</v-icon>
          <slot name="title"> Filter Berdasarkan </slot>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-0" style="height: 250px">
          <v-row class="mt-5">
            <v-col cols="12" md="12" sm="12" class="py-0">
              <span class="grey--text"> Tanggal Awal</span>
              <m-date-time-picker
                v-model="filters.wkt_mulai"
                prepend-inner-icon="mdi-calendar"
                placeholder="Waktu Mulai"
              />
            </v-col>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <span class="grey--text"> Tanggal Akhir</span>
              <m-date-time-picker
                v-model="filters.wkt_selesai"
                prepend-inner-icon="mdi-calendar"
                placeholder="Waktu Selesai"
                :min="filters.wkt_mulai"
              />
            </v-col>
            <v-col cols="12" md="6" sm="12" class="py-0">
              <span class="grey--text"> Tipe Pengisian</span>

              <v-select
                v-model="filters.k_tipe_pengisian"
                outlined
                :items="mapForMaster(M_PERIOD)"
                item-text="text"
                item-value="value"
                placeholder="Pilih Tipe Pengisian"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="py-0">
              <span class="grey--text"> Status Pengisian</span>
              <v-select
                v-model="filters.status_tayang"
                outlined
                :items="mapForMaster(modelStatus)"
                item-text="text"
                item-value="value"
                placeholder="Pilih Status Tayang"
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mb-5"></v-divider>
        <v-card-actions class="pr-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn depressed text color="warning" @click="onReset"> Reset Filter </v-btn>
          <v-btn name="simpan" depressed color="primary" @click="onFilter"> <v-icon>mdi-check</v-icon>Terapkan </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { isCan } from '@/tools'
import BlockCard from '@/components/BlockCard.vue'
import DlgChange from '../components/FormKuesioner.vue'
import MDateTimePicker from '@/components/MDateTimePicker.vue'

import { M_STATUS } from '../const'
import { mapForMaster } from '@/tools'
export default {
  components: {
    BlockCard,
    DlgChange,
    MDateTimePicker,
  },
  data() {
    return {
      textSearch: '',
      cp: 1,
      page: null,
      items: [],
      M_STATUS: M_STATUS,
      filters: {},
      modal: false,
      allUsers: [],
      allGroup: [],
      headers: [
        { text: 'Nama Kuesioner', align: 'left', value: 'nama' },
        { text: 'Status', align: 'left', value: 'status', sortable: false },
        { text: 'Responden', align: 'left', value: 'responden', sortable: false },
        { text: 'Pemilik', align: 'left', value: 'pemilik', sortable: false },
        { text: 'Terakhir Diubah', align: 'left', value: 'updated_at' },
        { text: '', align: 'left', sortable: false },
      ],
      M_PERIOD: {
        1: '1x Pengisian',
        2: 'Harian',
        3: 'Mingguan',
        4: 'Bulanan',
      },
      modelStatus: {
        1: 'Draft',
        2: 'Akan Tayang',
        3: 'Sedang Tayang',
        4: 'Selesai',
        5: 'Non-aktif',
      },
      more_menu: [
        {
          title: 'Detail',
          click: (i, o) => this.detil(o),
        },
        {
          title: 'Statistik',
          click: (i, o) => this.onStatistik(o),
        },
        {
          divider: true,
        },
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
          check: (i, o) => Number(o.status_tayang) === 1 && isCan('kuesioner.update'),
        },
        {
          title: 'Duplikat',
          click: (i, o) => this.toDuplicate(o) && isCan('kuesioner.duplikasi'),
        },
        {
          title: 'Tayangkan',
          click: (i, o) => this.onTayang(o),
          check: (i, o) => Number(o.status_tayang) === 1 && Number(o.status_tayang) !== 5 && isCan('kuesioner.tayang'),
        },
        {
          title: 'Batal Tayang',
          click: (i, o) => this.onTayang(o),
          check: (i, o) => Number(o.status_tayang) > 1 && Number(o.status_tayang) !== 5 && isCan('kuesioner.tayang'),
        },
        {
          title: 'Aktifkan',
          click: (i, o) => this.onAktif(o),
          check: (i, o) => Number(o.status_tayang) === 5 && isCan('kuesioner.non-aktif'),
        },
        {
          title: 'Non Aktifkan',
          click: (i, o) => this.onAktif(o),
          check: (i, o) => Number(o.status_tayang) < 5 && isCan('kuesioner.non-aktif'),
        },
        {
          title: 'Hapus',
          click: (i, o) => this.onHapus(o),
          check: (i, o) =>
            (Number(o.status_tayang) === 1 || Number(o.status_tayang) === 5) && isCan('kuesioner.destroy'),
        },
      ],
    }
  },
  activated() {
    this.load()
    this.loadUsers()
    this.loadGroups()
  },
  methods: {
    mapForMaster,
    load() {
      this.$store
        .dispatch('kuesioner/get', {
          organisasi_id: this.organisasi_id,
          params: Object.assign(
            {},
            {
              page: this.cp,
              keyword: this.textSearch,
            },
            this.filters
          ),
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    loadUsers() {
      this.$store
        .dispatch('user/getOrgs', {
          organisasi_id: this.organisasi_id,
          params: {
            is_aktif: 1,
          },
        })
        .then(({ data }) => {
          this.allUsers = data || []
        })
        .catch((e) => e)
    },
    loadGroups() {
      this.$store
        .dispatch('grup/get', {
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.allGroup = (data && data.data) || (data) || []
        })
        .catch((e) => e)
    },
    detil(item) {
      this.$store
        .dispatch('kuesioner/detail', {
          id: item.kuesioner_id,
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.$refs.kelola.open({ kuesioner: Object.assign({}, data, { jumlah: item.jumlah }) }, true)
        })
    },
    onStatistik(item) {
      this.$router.push({
        name: 'kuesioner.detail',
        params: { organisasi_id: this.organisasi_id, kuesioner_id: item.kuesioner_id },
      })
    },
    add() {
      this.$refs.kelola.open({})
    },
    edit(item) {
      this.$store
        .dispatch('kuesioner/detail', {
          id: item.kuesioner_id,
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.$refs.kelola.open({ kuesioner: Object.assign({}, data, { jumlah: item.jumlah_respons || 0 }) })
        })
    },
    onTayang(item) {
      const status = Number(item.status_tayang || 1)
      const label = status === 1 ? 'Tayangkan' : 'Batal Tayang'
      let msg = [`Apakah Anda yakin akan ${status === 1 ? 'menayangkan' : 'batal tayang'} kuesioner ini ?`]
      if (status > 1) {
        msg.push(`<div role="alert" class="v-alert v-sheet theme--light v-alert--text red--text mt-3 body-2"><div class="v-alert__wrapper"><i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-alert theme--light red--text"></i><div class="v-alert__content">
           ${
             status !== 1
               ? '<div class="mb-2">Jumlah responden eksisting di tulis di bawah deskripsi peringatan</div>'
               : ''
           }
           <div>Jumlah Responden: ${item.jumlah}</div>
           </div></div></div>`)
      }
      this.$confirmDanger(
        msg.join(''),
        { color: status === 1 ? 'primary' : 'red', okText: status === 1 ? 'Ya, Tayangkan' : 'Ya, Batal Tayang' },
        `${label} Kuesioner`
      ).then(() => {
        this.$store
          .dispatch('kuesioner/actions', {
            id: item.kuesioner_id,
            organisasi_id: this.organisasi_id,
            api: status === 1 ? 'tayang' : 'batal-tayang',
            type: 'get',
          })
          .then(() => {
            this.$success(`Kuesioner berhasil di ${status === 1 ? 'tayangkan' : 'batal tayang'}`)
            this.load()
          })
      })
    },
    toDuplicate(item) {
      this.$confirm(
        [
          '<div>Apakah Anda yakin untuk <b>Menguplikasi</b> Kuesioner ini?</div>',
          `<div role="alert" class="v-alert v-sheet theme--light v-alert--text primary--text mt-3 body-2"><div class="v-alert__wrapper"><i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-alert theme--light red--text"></i><div class="v-alert__content"><b data-v-5b974dbc="">Perhatian</b>
      semua komponen dari pertanyaan akan sama persis dengan kuesioner ini<br/>Kuesioner hasil duplikasi, tampil di urutan paling terakhir/paling bawah
    </div></div></div>`,
        ].join(''),
        {
          okText: 'Duplikat',
        },
        'Duplikat Kuesioner'
      ).then(() => {
        this.$store
          .dispatch('kuesioner/duplicate', { id: item.kuesioner_id, organisasi_id: this.organisasi_id })
          .then(() => {
            this.$success('Kuesioner berhasil di duplikasi')
            this.load()
          })
      })
    },
    onAktif(item) {
      const status = Number(item.status_tayang || 1)
      const label = status === 5 ? 'Aktifkan' : 'Non Aktifkan'
      this.$confirmDanger(
        `Apakah Anda yakin ingin ${status === 5 ? 'aktifkan' : 'non aktifkan'} kuesioner yang Anda pilih ?`,
        { color: status === 5 ? 'primary' : 'red' },
        `${label} Kuesioner`
      ).then(() => {
        this.$store
          .dispatch('kuesioner/actions', {
            id: item.kuesioner_id,
            organisasi_id: this.organisasi_id,
            api: status === 5 ? 'batal-tayang' : 'non-aktif',
            type: 'get',
          })
          .then(() => {
            this.$success(`Kuesioner berhasil di ${status === 5 ? 'aktifkan' : 'non aktifkan'}`)
            this.load()
          })
      })
    },
    onHapus(item) {
      this.$confirm(
        [
          '<div>Apakah Anda yakin akan menghapus Kuesioner ini ?</div>',
          `<div>Tindakan ini tidak dapat dikembalikan</div>`,
          `<div role="alert" class="v-alert v-sheet theme--light v-alert--text red--text mt-3 body-2"><div class="v-alert__wrapper"><i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-alert theme--light red--text"></i><div class="v-alert__content"><b data-v-5b974dbc="">Peringatan</b>
           kuesioner akan terhapus dan tidak dapat diakses kembali
           </div></div></div>`,
        ].join(''),
        {
          okText: 'Tidak',
          cancelText: 'Ya Hapus',
          color: 'red',
        },
        'Hapus Kuesioner'
      )
        .then(() => {})
        .catch(() => {
          this.$store
            .dispatch('kuesioner/drop', {
              id: item.kuesioner_id,
              organisasi_id: this.organisasi_id,
            })
            .then(() => {
              this.$success(`Kuesioner berhasil di hapus`)
              this.load()
            })
        })
    },
    onFilter() {
      this.load()
      this.modal = false
    },
    onReset() {
      this.filters = {}
      this.load()
      this.modal = false
    },
  },
}
</script>
<style scoped>
.elevation-custom {
  -webkit-box-shadow: 0px 0px 10px 3px #4362be56 !important;
}
</style>
